/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ClinicalLicenseMailSubscriberListResponse } from '../models/clinical-license-mail-subscriber-list-response';
import { ClinicalLicenseMailSubscriberRequest } from '../models/clinical-license-mail-subscriber-request';
import { ClinicalLicenseMailSubscriberResponse } from '../models/clinical-license-mail-subscriber-response';
import { CreateClinicalLicenseMailSubscribersRequest } from '../models/create-clinical-license-mail-subscribers-request';
import { GenericResponse } from '../models/generic-response';

/**
 * Training Department license mail subscribers. Not privilege workflow subscribers.
 */
@Injectable({ providedIn: 'root' })
export class ClinicalLicenseMailSubscribersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listClinicalLicenseMailSubscribers()` */
  static readonly ListClinicalLicenseMailSubscribersPath =
    '/api/v1/clinical-privileges/license-mail-subscribers';

  /**
   * List Training Department license mail subscribers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listClinicalLicenseMailSubscribers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listClinicalLicenseMailSubscribers$Response(
    params?: {
      search?: string;
      sort?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClinicalLicenseMailSubscriberListResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClinicalLicenseMailSubscribersService.ListClinicalLicenseMailSubscribersPath,
      'get'
    );
    if (params) {
      rb.query('search', params.search, {});
      rb.query('sort', params.sort, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClinicalLicenseMailSubscriberListResponse>;
        })
      );
  }

  /**
   * List Training Department license mail subscribers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listClinicalLicenseMailSubscribers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listClinicalLicenseMailSubscribers(
    params?: {
      search?: string;
      sort?: string;
    },
    context?: HttpContext
  ): Observable<ClinicalLicenseMailSubscriberListResponse> {
    return this.listClinicalLicenseMailSubscribers$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<ClinicalLicenseMailSubscriberListResponse>
        ): ClinicalLicenseMailSubscriberListResponse => r.body
      )
    );
  }

  /** Path part for operation `createClinicalLicenseMailSubscribers()` */
  static readonly CreateClinicalLicenseMailSubscribersPath =
    '/api/v1/clinical-privileges/license-mail-subscribers';

  /**
   * Add Training Department license mail subscribers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createClinicalLicenseMailSubscribers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createClinicalLicenseMailSubscribers$Response(
    params: {
      body: CreateClinicalLicenseMailSubscribersRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClinicalLicenseMailSubscriberListResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClinicalLicenseMailSubscribersService.CreateClinicalLicenseMailSubscribersPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClinicalLicenseMailSubscriberListResponse>;
        })
      );
  }

  /**
   * Add Training Department license mail subscribers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createClinicalLicenseMailSubscribers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createClinicalLicenseMailSubscribers(
    params: {
      body: CreateClinicalLicenseMailSubscribersRequest;
    },
    context?: HttpContext
  ): Observable<ClinicalLicenseMailSubscriberListResponse> {
    return this.createClinicalLicenseMailSubscribers$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<ClinicalLicenseMailSubscriberListResponse>
        ): ClinicalLicenseMailSubscriberListResponse => r.body
      )
    );
  }

  /** Path part for operation `deleteClinicalLicenseMailSubscriber()` */
  static readonly DeleteClinicalLicenseMailSubscriberPath =
    '/api/v1/clinical-privileges/license-mail-subscribers/{id}';

  /**
   * Delete a license mail subscriber.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteClinicalLicenseMailSubscriber()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClinicalLicenseMailSubscriber$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClinicalLicenseMailSubscribersService.DeleteClinicalLicenseMailSubscriberPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete a license mail subscriber.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteClinicalLicenseMailSubscriber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClinicalLicenseMailSubscriber(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteClinicalLicenseMailSubscriber$Response(
      params,
      context
    ).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateClinicalLicenseMailSubscriber()` */
  static readonly UpdateClinicalLicenseMailSubscriberPath =
    '/api/v1/clinical-privileges/license-mail-subscribers/{id}';

  /**
   * Update a license mail subscriber.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateClinicalLicenseMailSubscriber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateClinicalLicenseMailSubscriber$Response(
    params: {
      id: number;
      body: ClinicalLicenseMailSubscriberRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClinicalLicenseMailSubscriberResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClinicalLicenseMailSubscribersService.UpdateClinicalLicenseMailSubscriberPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClinicalLicenseMailSubscriberResponse>;
        })
      );
  }

  /**
   * Update a license mail subscriber.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateClinicalLicenseMailSubscriber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateClinicalLicenseMailSubscriber(
    params: {
      id: number;
      body: ClinicalLicenseMailSubscriberRequest;
    },
    context?: HttpContext
  ): Observable<ClinicalLicenseMailSubscriberResponse> {
    return this.updateClinicalLicenseMailSubscriber$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<ClinicalLicenseMailSubscriberResponse>
        ): ClinicalLicenseMailSubscriberResponse => r.body
      )
    );
  }
}
